/**
 * @flow
 * @relayHash 814dc7192d1bf0ab96b2b3fabf6ec687
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ActivateStaffUserInput = {|
  id: string,
  prorationTimestamp?: ?string,
  clientMutationId?: ?string,
|};
export type ActivateStaffUserMutationVariables = {|
  input: ActivateStaffUserInput
|};
export type ActivateStaffUserMutationResponse = {|
  +activateStaffUser: ?{|
    +updatedStaffUser: ?{|
      +id: string,
      +user: {|
        +isActive: ?boolean
      |},
    |}
  |}
|};
export type ActivateStaffUserMutation = {|
  variables: ActivateStaffUserMutationVariables,
  response: ActivateStaffUserMutationResponse,
|};
*/


/*
mutation ActivateStaffUserMutation(
  $input: ActivateStaffUserInput!
) {
  activateStaffUser(input: $input) {
    updatedStaffUser {
      id
      user {
        isActive
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "ActivateStaffUserInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isActive",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ActivateStaffUserMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "activateStaffUser",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "ActivateStaffUserPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "updatedStaffUser",
            "storageKey": null,
            "args": null,
            "concreteType": "StaffNode",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "user",
                "storageKey": null,
                "args": null,
                "concreteType": "UserNode",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ActivateStaffUserMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "activateStaffUser",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "ActivateStaffUserPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "updatedStaffUser",
            "storageKey": null,
            "args": null,
            "concreteType": "StaffNode",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "user",
                "storageKey": null,
                "args": null,
                "concreteType": "UserNode",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v2/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "ActivateStaffUserMutation",
    "id": null,
    "text": "mutation ActivateStaffUserMutation(\n  $input: ActivateStaffUserInput!\n) {\n  activateStaffUser(input: $input) {\n    updatedStaffUser {\n      id\n      user {\n        isActive\n        id\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '5eef2940ceb01c45240e2303287579a4';
module.exports = node;
